export const KYC_IN_REVIEW_IDV_EVENTS = {
  VIEW_KYC_IN_REVIEW_IDV_PAGE: 'view_kyc_in_review_idv',
  SELECT_KYC_IN_REVIEW_IDV_GO_TO_VERIFICATION:
    'select_kyc_in_review_idv_go_to_verification',
  VIEW_KYC_IN_REVIEW_IDV_PLAID_SHOW_WEBVIEW:
    'view_kyc_in_review_idv_plaid_show_webview',
  VIEW_KYC_IN_REVIEW_IDV_PLAID_SUCCESS: 'view_kyc_in_review_idv_plaid_success',
  VIEW_KYC_IN_REVIEW_IDV_PLAID_ERROR: 'view_kyc_in_review_idv_plaid_error',
  SELECT_KYC_IN_REVIEW_IDV_PLAID_EXIT: 'select_kyc_in_review_idv_plaid_exit',
} as const;
